import React from "react";
import { FileText, RefreshCw } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function DigestPanel({ digest, onRegenerate, loading, navigate }) {
  const d = digest?.data || {};
  const a = d.alerts || {};
  const fmtDate = (iso) => {
    try { return new Date(iso).toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" }); } catch { return iso; }
  };
  const totalAlerts = (a.oil_low ? 1 : 0) + (a.low_stock || 0) + (a.defect_cars || 0) + (a.defect_equipment || 0) + (a.mfk_expired || 0) + (a.revizie_due || 0);
  return (
    <div className="card-flat p-5 mb-10 border-l-4 border-l-[var(--primary)]" data-testid="digest-panel">
      <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-md bg-[var(--primary-subtle)] grid place-items-center text-[var(--primary)]"><FileText size={20}/></div>
          <div>
            <div className="font-display text-lg font-bold">Raport săptămânal · {d.week || "—"}</div>
            <div className="text-xs text-zinc-500 mt-0.5">Săptămâna începând cu {fmtDate(d.monday)} · generat de {digest.generated_by || "—"} la {fmtDate(digest.created_at)}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={async () => {
              try {
                const { data } = await api.post(`/email/digest${digest?.id ? `?digest_id=${digest.id}` : ""}`);
                toast.success(`Digest trimis pe email la ${data.to}`);
              } catch (e) { toast.error(e?.response?.data?.detail || "Eroare la trimitere"); }
            }}
            data-testid="digest-email-btn"
            className="text-xs px-3 py-1.5 rounded-md border border-[var(--border)] hover:border-[var(--primary)] text-zinc-600 hover:text-[var(--primary)] inline-flex items-center gap-1.5"
            title="Trimite acest raport pe email"
          >
            📧 Trimite pe email
          </button>
          <button
            onClick={onRegenerate}
            disabled={loading}
            data-testid="digest-regenerate"
            className="text-xs px-3 py-1.5 rounded-md border border-[var(--border)] hover:border-[var(--primary)] text-zinc-600 hover:text-[var(--primary)] inline-flex items-center gap-1.5 disabled:opacity-50"
          >
            <RefreshCw size={12} className={loading ? "animate-spin" : ""}/>
            {loading ? "Se generează…" : "Regenerează"}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Alerte */}
        <div className="border-l-2 border-l-[var(--red-bila)] pl-3">
          <div className="small-label text-[var(--red-bila)] mb-2">Alerte critice ({totalAlerts})</div>
          <ul className="text-sm space-y-1">
            {a.oil_low && <li>· Stoc ulei sub prag: <strong>{a.oil_total_l} L</strong></li>}
            {a.low_stock > 0 && <li>· {a.low_stock} {a.low_stock === 1 ? "produs" : "produse"} cu stoc minim</li>}
            {a.defect_cars > 0 && <li>· {a.defect_cars} {a.defect_cars === 1 ? "autoturism defect" : "autoturisme defecte"}</li>}
            {a.defect_equipment > 0 && <li>· {a.defect_equipment} {a.defect_equipment === 1 ? "echipament defect" : "echipamente defecte"}</li>}
            {a.mfk_expired > 0 && <li>· {a.mfk_expired} MFK expirat{a.mfk_expired === 1 ? "" : "e"}</li>}
            {a.revizie_due > 0 && <li>· {a.revizie_due} revizi{a.revizie_due === 1 ? "e scadentă" : "i scadente"}</li>}
            {totalAlerts === 0 && <li className="text-[var(--green-valid)]">✓ Nicio alertă critică</li>}
          </ul>
        </div>

        {/* Top ore */}
        <div className="border-l-2 border-l-[var(--primary)] pl-3">
          <div className="small-label text-[var(--primary)] mb-2">Top 3 ore lucrate (luna curentă)</div>
          <ul className="text-sm space-y-1">
            {(d.top_hours || []).map((h, i) => (
              <li key={i}>{i + 1}. <strong>{h.name}</strong> — {h.hours} h</li>
            ))}
            {(!d.top_hours || d.top_hours.length === 0) && <li className="text-zinc-400 italic">Nicio înregistrare luna asta.</li>}
          </ul>
        </div>

        {/* Combustibil */}
        <div className="border-l-2 border-l-[#FF8A00] pl-3">
          <div className="small-label text-[#FF8A00] mb-2">Combustibil ultimele 7 zile</div>
          <div className="text-sm space-y-1">
            <div>Total: <strong className="text-[#FF8A00]">{d.fuel_week?.liters || 0} L</strong></div>
            <div>Alimentări: <strong>{d.fuel_week?.fills || 0}</strong></div>
            <button onClick={() => navigate("/management")} className="text-xs text-[var(--primary)] hover:underline mt-2">Vezi grafic →</button>
          </div>
        </div>
      </div>
    </div>
  );
}
